import React, { createContext } from "react";
import { Skeleton } from "primereact/skeleton";
import { Outlet, useParams } from "react-router-dom";

import Layout from "../../../Layout";
import useLspUpdating from "../actions/useLspUpdating";
import LspSideBar from "./components/LspSidabar";

const EntityContext = createContext();
const Lsps = () => {
  const { id } = useParams();
  const { lspdata, genstate } = useLspUpdating(id, true);

  return (
    <EntityContext.Provider>
      <Layout
        title={`Core Partner Information`}
        subtitle={`Find all of the code of the information regarding this service partner here...`}
        crumbs={[
          { label: "Local Service Partners", url: "/lsp" },
          {
            label: (
              <div className="flex">
                {genstate.status === "getlsploading" ? (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                ) : (
                  lspdata?.name
                )}
              </div>
            ),
            id: "lsp",
            url: `/lsp/${id}/dashboard`,
          },
          { label: "Core Partner Information", id: "core-lsp-data" },
        ]}
      >
        <div className="grid grid-nogutter">
          <div className="col-12 Entities-container">
            <div className="grid">
              <div className="col-3">
                <LspSideBar activeTab={genstate.activeTab} id={id} />
              </div>
              <div className="col-9">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </EntityContext.Provider>
  );
};
export default Lsps;
